$ ->
  $('.cw_richtext').summernote
    tooltip: false
$ ->
  $('.cw_richtext').summernote
    tooltip: false
